var map = {
	"./ANewUser.svg": 98800,
	"./Atransaction.svg": 81820,
	"./Map-2.svg": 45169,
	"./Payment.svg": 91648,
	"./Scheduling.svg": 37068,
	"./alipay.svg": 87018,
	"./analysis.svg": 47961,
	"./barcode.svg": 40079,
	"./bin-full.svg": 37518,
	"./bind.svg": 50594,
	"./bo-ticket.svg": 35858,
	"./bottomArrow.svg": 25372,
	"./building.svg": 54256,
	"./configuration.svg": 94994,
	"./dashboard.svg": 48765,
	"./data-check.svg": 25157,
	"./dept.svg": 87055,
	"./dictionary.svg": 91819,
	"./disinfection.svg": 58182,
	"./droplet.svg": 23939,
	"./email.svg": 34413,
	"./empty.svg": 75972,
	"./error-card.svg": 34031,
	"./error.svg": 1523,
	"./error_1.svg": 15330,
	"./file-display.svg": 71844,
	"./file-mp4.svg": 25243,
	"./filebox.svg": 7924,
	"./home.svg": 25702,
	"./hourData.svg": 7361,
	"./icon_charity.svg": 2886,
	"./language.svg": 57487,
	"./language_1.svg": 48395,
	"./leftArrow.svg": 50201,
	"./link.svg": 84173,
	"./log.svg": 83961,
	"./machine.svg": 99415,
	"./mail-error.svg": 19634,
	"./maintenance.svg": 99718,
	"./map-city.svg": 33252,
	"./map.svg": 25818,
	"./menu.svg": 91949,
	"./nacos.svg": 47894,
	"./notice.svg": 89721,
	"./pencil.svg": 82852,
	"./place.svg": 50586,
	"./platform.svg": 79530,
	"./prohibit.svg": 74345,
	"./project.svg": 52196,
	"./prompt.svg": 57017,
	"./recycle.svg": 96811,
	"./recycleData.svg": 50408,
	"./reject.svg": 36687,
	"./rightArrow.svg": 54153,
	"./roles.svg": 38541,
	"./security.svg": 53002,
	"./sentinel.svg": 22302,
	"./setting.svg": 62130,
	"./shield-flash.svg": 88704,
	"./swagger.svg": 46996,
	"./time.svg": 54570,
	"./topArrow.svg": 57147,
	"./transaction.svg": 13534,
	"./unmaintenance.svg": 1838,
	"./user-manage.svg": 49478,
	"./user-set.svg": 93274,
	"./user.svg": 51324,
	"./userlist.svg": 18948,
	"./version.svg": 9821,
	"./video.svg": 96451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;